var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9839 6.45161H22.5806V0H2.41935V6.45161H2.01613C0.904436 6.45161 0 7.35605 0 8.46774V20.5645C0 21.6762 0.904436 22.5806 2.01613 22.5806H7.25806V24.1935H5.64516V25H19.3548V24.1935H17.7419V22.5806H22.9839C24.0956 22.5806 25 21.6762 25 20.5645V8.46774C25 7.35605 24.0956 6.45161 22.9839 6.45161ZM3.22581 4.03226H21.7742V16.9355H3.22581V4.03226ZM21.7742 0.806452V3.22581H3.22581V0.806452H21.7742ZM2.01613 7.25806H2.41935V17.7419H22.5806V7.25806H22.9839C23.6508 7.25806 24.1935 7.80081 24.1935 8.46774V19.3548H0.806452V8.46774C0.806452 7.80081 1.34919 7.25806 2.01613 7.25806ZM16.9355 24.1935H8.06452V22.5806H16.9355V24.1935ZM22.9839 21.7742H2.01613C1.34919 21.7742 0.806452 21.2315 0.806452 20.5645V20.1613H24.1935V20.5645C24.1935 21.2315 23.6508 21.7742 22.9839 21.7742Z",
    fill: "#5956E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7212 6H12.2787C11.0225 6 10 6.92025 10 8.05087V8.625H10.8333V8.05087C10.8333 7.3335 11.4817 6.75 12.2787 6.75H12.7212C13.5183 6.75 14.1667 7.3335 14.1667 8.05087C14.1667 8.50537 13.8975 8.93288 13.4646 9.1665L12.0833 9.91275V12H12.9167V10.3372L13.8938 9.80963C14.5763 9.44138 15 8.76712 15 8.05087C15 6.92025 13.9775 6 12.7212 6Z",
    fill: "#E541ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13C11.673 13 11 13.4487 11 14C11 14.5513 11.673 15 12.5 15C13.327 15 14 14.5513 14 14C14 13.4487 13.327 13 12.5 13ZM12.5 14.3333C12.2245 14.3333 12 14.1837 12 14C12 13.8163 12.2245 13.6667 12.5 13.6667C12.7755 13.6667 13 13.8163 13 14C13 14.1837 12.7755 14.3333 12.5 14.3333Z",
    fill: "#E541ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H4V6H9V5Z",
    fill: "#5956E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H4V9H9V8Z",
    fill: "#E541ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H4V12H9V11Z",
    fill: "#5956E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H16V10H21V9Z",
    fill: "#5956E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H16V13H21V12Z",
    fill: "#E541ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H16V16H21V15Z",
    fill: "#5956E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.78e480f6ef02a9299c584cf97b134e3f.svg";
export { ForwardRef as ReactComponent };